import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable, Subject, Subscription } from 'rxjs';

import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

import { AutoTodoRule } from '../../../models/auto-todo-rule';

import { AutoTodoRuleService } from '../../../services/auto_rules/auto-todo-rule.service';
import { NotyService } from '../../../services/common/noty.service';

@Component({
  selector: 'app-auto-todo-rule-form',
  templateUrl: './auto-todo-rule-form.component.html',
  styleUrls: ['./auto-todo-rule-form.component.scss'],
})
export class AutoTodoRuleFormComponent implements OnInit {
  autoTodoRuleId: number;

  autoTodoRule: AutoTodoRule = new AutoTodoRule();

  documentTypeSearchTermChanged: Subject<string> = new Subject<string>();

  documentTypeSearchSubscription: Subscription;

  formOptions: any = {};

  loading: boolean = true;

  saving: boolean = false;

  documentTypeFilter: any = { showAs: 'list' };

  constructor(private notyService: NotyService, private location: Location, private route: ActivatedRoute, private router: Router, private autoTodoRuleService: AutoTodoRuleService) {}

  // Component lifecycle methods
  ngOnInit() {
    this.loading = true;
    this.autoTodoRuleService.formOptions().then((response_json) => {
      this.loading = false;
      this.formOptions = response_json;
      let documentTypes: any = {};
      for (let documentType of response_json.document_types) {
        documentType.children = [];
        documentType.expanded = true;
        documentTypes[documentType.id] = documentType;
      }
      let documentTypeList: Array<any> = [];
      for (let documentType of response_json.document_types)
        if (documentType.parent_id) {
          documentTypes[documentType.parent_id].children.push(documentType);
          documentType.parent = documentTypes[documentType.parent_id];
        } else documentTypeList.push(documentType);
      this.formOptions.document_types_tree = documentTypeList;
      this.autoTodoRuleId = this.route.snapshot.params['id'];
      if (this.autoTodoRuleId)
        this.autoTodoRuleService.edit(this.autoTodoRuleId).then((response_json) => {
          this.autoTodoRule = response_json.auto_todo_rule;
          for (let documentTypeId of this.autoTodoRule.document_type_ids)
            for (let documentType of this.formOptions.document_types)
              if (documentTypeId == documentType.id) {
                documentType.selected = true;
                this.markSelectedDocumentTypeParents(documentType);
                break;
              }
        });
    });
    this.documentTypeSearchSubscription = this.documentTypeSearchTermChanged
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        switchMap((search) => this.searchDocumentTypes())
      )
      .subscribe(() => {});
  }

  // Component methods
  back() {
    this.location.back();
  }

  markSelectedDocumentTypeParents(documentType: any) {
    let parentDocumentType: any = documentType.parent;
    while (parentDocumentType) {
      parentDocumentType.childSelected = true;
      parentDocumentType = parentDocumentType.parent;
    }
  }

  nextDocumentTypeTerm() {
    if (this.documentTypeFilter.prefix) this.documentTypeFilter.showAs = 'list';
    this.documentTypeSearchTermChanged.next(this.documentTypeFilter.prefix);
  }

  searchDocumentTypes(): Observable<any> {
    for (let documentType of this.formOptions.document_types)
      if (String(documentType.prefix).toLowerCase().indexOf(this.documentTypeFilter.prefix) === 0) documentType.searchResult = true;
      else documentType.searchResult = false;
    return new Observable();
  }

  selectDocumentType(documentType: any) {
    this.setDocumentTypesSelection(documentType.children, documentType.selected || false);
  }

  setDocumentTypesSelection(documentTypes: Array<any>, selection: boolean = false) {
    for (let documentType of documentTypes) {
      documentType.selected = selection;
      documentType.childSelected = false;
      this.markSelectedDocumentTypeParents(documentType);
      this.setDocumentTypesSelection(documentType.children || [], selection);
    }
  }

  save() {
    this.saving = true;
    this.autoTodoRule.document_type_ids = [];
    for (let documentType of this.formOptions.document_types) if (documentType.selected) this.autoTodoRule.document_type_ids.push(documentType.id);
    this.autoTodoRuleService
      .save(this.autoTodoRule)
      .then((response_json) => {
        this.saving = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Auto todo rule saved', 'success');
          this.router.navigateByUrl('/auto_todo_rules');
        } else this.notyService.notify(response_json.text || 'Error saving auto todo rule', 'error');
      })
      .catch(() => {
        this.saving = false;
        this.notyService.notify('Error saving auto todo rule', 'error');
      });
  }
}
